import { createAction } from 'redux-act';

export const setLoading = createAction('quote/SET_LOADING');
export const createQuote = createAction('quote/FETCH_QUOTE');
export const createQuoteSuccess = createAction('quote/FETCH_QUOTE_SUCCESS');
export const createQuoteFailure = createAction('quote/FETCH_QUOTE_FAILURE');
export const clearQuote = createAction('quote/CLEAR_QUOTE');
